// 2026-05-16 — localStorage.clear() 호출 시 사용자 설정까지 함께 날아가는 회귀 방지.
//
// 기존 동작: 토큰 갱신 실패·로그아웃·survey 백 등에서 localStorage.clear() 호출.
// 부작용: redLightDisabledDecks 같은 디바이스-로컬 사용자 설정이 통째로 삭제되어
// 다음 접속 시 "빨간불 끄기" 토글이 풀려 보임 (사용자 보고).
//
// 처방: clearAuthStorage() 가 PRESERVE_KEYS 만 백업 후 clear, 다시 복원.
// 새 설정 키 추가 시 아래 PRESERVE_KEYS 한 줄만 추가하면 자동 보존됨.

const PRESERVE_KEYS = ["redLightDisabledDecks"];

export function clearAuthStorage(): void {
  const preserved: Record<string, string> = {};
  for (const key of PRESERVE_KEYS) {
    const v = window.localStorage.getItem(key);
    if (v !== null) preserved[key] = v;
  }
  window.localStorage.clear();
  for (const [k, v] of Object.entries(preserved)) {
    try {
      window.localStorage.setItem(k, v);
    } catch {
      /* 시크릿 모드 등 — 무시 */
    }
  }
}
